<template>
  <fragment v-if="campaign && campaignEditFinishData">
    <label v-if="campaign.ChannelProjectType === ProjectType.ExternalAPI">{{ $t("CampaignEdit.Finish.ProjectPropertyMapping") }}</label>
    <label v-else>{{ $t("CampaignEdit.Finish.CampaignLinks") }}</label>
    <ul v-if="campaignEditFinishData.CampaignUrls && campaignEditFinishData.CampaignUrls.length > 0" class="campaign-urls">
      <li v-for="(url, index) in campaignEditFinishData.CampaignUrls" :key="url">
        <div v-if="index > 0">{{ $t("Or") }}</div>
        <a :href="url" target="_blank">{{ url }}</a>
      </li>
    </ul>
    <template v-if="campaign.ChannelProjectType !== ProjectType.ExternalAPI">
      <div v-if="campaignEditFinishData.CampaignMobileUrls && campaignEditFinishData.CampaignMobileUrls.length > 0">
        <label>{{ $t("CampaignEdit.Finish.MobileVersions") }}</label>
        <ul class="campaign-urls">
          <li v-for="(url, index) in campaignEditFinishData.CampaignMobileUrls" :key="url">
            <div v-if="index > 0">{{ $t("Or") }}</div>
            <a :href="url" target="_blank">{{ url }}</a>
          </li>
        </ul>
      </div>
      <div v-html="$t('CampaignEdit.Finish.AdditionalParameters')"></div>
      <div v-for="url in campaignEditFinishData.CampaignUrls" :key="url">
        <a :href="url + tag" target="_blank">{{ url + tag }}</a>
      </div>
      <div v-html="$t('CampaignEdit.Finish.AdditionalParameters2')"></div>
    </template>
  </fragment>
</template>

<script lang="ts">
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/he";
import { Getter } from "vuex-class";
import { ProjectType } from "@/models/assets/ProjectType";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditFinishData } from "@/models/campaigns/CampaignEditFinishData";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import CampaignService from "@/services/CampaignService";
import CampaignsApiService from "@/services/api/CampaignsApiService";
import IconBase from "../IconBase.vue";
import IconCalendar from "../icons/IconCalendar.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";

Vue.use(Fragment.Plugin);
const namespace = "campaignsModule";

@Component({
  components: {
    DatePicker,
    IconBase,
    IconCalendar,
    IconCaretDown,
  },
})
export default class TabFinish extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;

  //#endregion Vuex getters and actions


  //#region Properties

  tag = "&FIX_TAG=testTag";
  campaignEditFinishData?: CampaignEditFinishData = {
    CampaignMobileUrls: [],
    CampaignUrls: []
  };

  CampaignEditPageKind = CampaignEditPageKind;
  ProjectType = ProjectType;

  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
    CampaignsApiService.getCampaignEditFinishData(this.campaign).then((data: CampaignEditFinishData) => {
      this.campaignEditFinishData = data;
    });
  }

  //#endregion Watchers


  //#region Getters

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get pageKind(): CampaignEditPageKind {
    return CampaignService.getCampaignEditPageKind(this.$route.path);
  }

  //#endregion Getters


  //#region Handlers



  //#endregion Handlers
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

ul.campaign-urls {
  list-style: disc;
  margin-bottom: 1rem;

  li {
    margin-left: 1.2rem;
  }
}
</style>
